import { YieldbirdWrapperAgentPage } from 'features/yieldbirdWrapperAgent/pages/YieldbirdWrapperAgentPage'
import AuthorizedRoute from 'providers/router/components/AuthorizedRoute'
import { ROUTES } from './routePaths'

import type { RouteObject } from 'react-router-dom'

export const yieldbirdWrapperAgentRoutes: RouteObject[] = [
  {
    element: (
      <AuthorizedRoute
        access='YieldbirdWrapperAgentPage'
        page={<YieldbirdWrapperAgentPage />}
      />
    ),
    path: ROUTES.YIELDBIRD_WRAPPER_AGENT,
  },
]
